import React from "react";
import { Container, Col, Row } from "react-bootstrap";

const PurchaseAndExpanse = () => {
  return (
    <div id="main">
      <Container>
        <Row>
          <Col xl="12"></Col>
        </Row>
      </Container>
    </div>
  );
};

export default PurchaseAndExpanse;
